import { StaffTemplate, BareStaffTemplate } from '../types/staffTemplate';
import { Property } from '../types/property';
import { searchById } from './functional';
import { ResourceNotFoundError } from '../errors';
import { minutesToTime, timeToMinutes, timeToString } from './time';
import { StaffAllocation } from '../types/staffAllocation';
import { Time } from '../types/time';
import { HourFormat } from '../types/brand';

export const STAFF_TEMPLATES_COLUMNS = ['Department', 'Title', 'Berthing', 'Forecasted Qty.'];
export const populateStaffTemplate = (
  bareTemplate: BareStaffTemplate,
  property: Property
): StaffTemplate => {
  let department = searchById(bareTemplate.department, property.brand.staffDepartments);
  if (!department) {
    throw new ResourceNotFoundError(`Cannot find referenced department ${bareTemplate.department}`);
  }
  let berthing = searchById(bareTemplate.berthing, property.staffBerthings || []);
  if (!berthing) {
    throw new ResourceNotFoundError(`Cannot find referenced berthing ${bareTemplate.berthing}`);
  }

  return {
    ...bareTemplate,
    department,
    berthing,
    property,
  };
};

export function getStaffTime(
  staffAllocation: StaffAllocation,
  time: Time,
  hourFormat: HourFormat
): string {
  let eventStartTime = timeToMinutes(time);
  let startTime = minutesToTime(eventStartTime + staffAllocation.startTime);
  let endTime = minutesToTime(
    eventStartTime + staffAllocation.startTime + staffAllocation.duration
  );

  let startTimeStr = timeToString(startTime, hourFormat, 'compact');
  let endTimeStr = timeToString(endTime, hourFormat, 'compact');

  return `${startTimeStr} - ${endTimeStr}`;
}
